import { ComponentInstall } from "../../utils";
import Dropdown from "./src";

export default ComponentInstall(Dropdown);
